import {
    BloggerRegistrationDto,
    BloggerRegistrationModel,
    BusinessRegistrationDto,
    BusinessRegistrationModel,
    RegistrationDto,
    RegistrationModel,
} from '../../data-layer/business/types';
import { addProtocol } from '../../utils/addProtocol';

const toRegistrationPersistenceDto = (model: RegistrationModel): RegistrationDto => ({
    instagram_url: model.instagramUrl,
    telegram_url: model.telegramUrl,
    vk_url: model.vkUrl,
    youtube_url: model.youtubeUrl,
    offer_agreement: model.offerAgreement,
    email: model.email,
    send_ad_mails: model.sendAdMails,
    other_url: model.otherUrl,
    need_cpa_registration: model.needCpaRegistration,
});

export const toBusinessRegistrationPersistenceDto = (
    model: BusinessRegistrationModel,
): BusinessRegistrationDto => ({
    ...toRegistrationPersistenceDto(model),
    domain: addProtocol(model.domain),
    display_name: model.displayName,
});

export const toBloggerRegistrationPersistenceDto = (
    model: BloggerRegistrationModel,
): BloggerRegistrationDto => ({
    ...toRegistrationPersistenceDto(model),
    bloggers_register_url: model.bloggersRegisterUrl,
});
